import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Typography } from '@naf-simba/building-blocks-typography';
import { colors } from '@naf-simba/theme';
import { PollStyleVariant } from './Poll.types';

export const Wrapper = styled.div<{ $style: PollStyleVariant }>`
  width: 100%;
  margin-top: ${spacing.space24};
  margin-bottom: ${spacing.space24};
`;

export const Container = styled.div<{ $style: PollStyleVariant }>`
  max-width: 764px;
  margin: 0 auto;
  padding: ${spacing.space24};
  border-radius: ${spacing.space20};
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 24%);

  ${({ $style }) =>
    $style === 'spruce'
      ? css`
          color: ${nafColor.signature.white};
          background-color: ${colors.secondary[900]};
        `
      : css`
          color: ${nafColor.signature.black};
          background-color: ${nafColor.signature.white};
        `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space12};
`;

export const Title = styled(Typography)`
  padding-top: ${spacing.space8};
  padding-bottom: ${spacing.space4};
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space12};
  width: 100%;
`;

export const OptionButton = styled.button<{ $isSelected: boolean; $isVoted: boolean }>`
  padding: ${spacing.space16};
  border: 1px solid ${nafColor.neutral.neutral4};
  border-radius: ${spacing.space8};
  text-align: left;
  cursor: ${({ $isVoted }) => ($isVoted ? 'default' : 'pointer')};
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  color: ${nafColor.signature.black};
  background-color: ${nafColor.signature.white};
  min-height: 28px;

  &:hover:not(:disabled) {
    background-color: ${nafColor.neutral.neutral2};
  }
`;

export const ProgressBar = styled.div<{ $percentage: number; $isSelected: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${({ $percentage }) => $percentage}%;
  border-radius: ${spacing.space8};
  z-index: 0;

  --target-width: ${({ $percentage }) => $percentage}%;

  /* Start from 0 and animate to target width */
  animation: grow-width 0.8s cubic-bezier(0.4, 0, 0.2, 1);

  @keyframes grow-width {
    from {
      width: 0%;
    }

    to {
      width: var(--target-width);
    }
  }

  ${({ $isSelected }) => css`
    background-color: ${$isSelected ? colors.secondary[300] : colors.secondary[100]};
  `}
`;

export const OptionText = styled(Typography)`
  flex: 1;
  z-index: 1;
`;

export const OptionPercentage = styled(Typography)`
  margin-left: ${spacing.space12};
  z-index: 1;
`;

export const VoteCount = styled(Typography)`
  padding-top: ${spacing.space4};
`;

export const MediaWrapper = styled.div`
  width: 100%;
  margin: ${spacing.space16} 0;
  border-radius: ${spacing.space12};
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    border-radius: ${spacing.space12};
  }
`;
